import axios from "axios";
import Config from "../utils/Config";


class ChatService {

    config = {
        headers: {
            Authorization: "",
            CompanyId: "",
        },
    };

    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;
    }

    async getUserChat(userId, companyId, accessToken) {
        // this.setAccessToken(accessToken, companyId);

        const data = await axios.get(
            Config.BACKEND_URL + `/api/chat/user/${userId}`,
            // this.config
        )
        return data;
    }

    async getGroupChat(userId, companyId, accessToken) {
        // this.setAccessToken(accessToken, companyId);

        const data = await axios.get(
            Config.BACKEND_URL + `/api/group/user/${userId}`,
            // this.config
        )
        return data;
    }

    async getUserMeetingGroups(userId, signal = null) {
        const config = signal ? { signal } : {};
        const data = await axios.get(
            Config.BACKEND_URL + `/api/group/user/${userId}`,
            config
        )
        return data;
    }

    async createPrivateChat(formData) {
        // this.setAccessToken(accessToken, companyId);

        const data = await axios.post(
            Config.BACKEND_URL + `/api/chat/chat`,
            formData
            // this.config
        )
        return data;
    }

    async createGroupChat(formData) {
        // this.setAccessToken(accessToken, companyId);

        const data = await axios.post(
            Config.BACKEND_URL + `/api/group/chat`,
            formData
            // this.config
        )
        return data;
    }

    async postPrivateChat(formData) {
        // this.setAccessToken(accessToken, companyId);

        const data = await axios.post(
            Config.BACKEND_URL + `/api/chat/message`,
            formData
            // this.config
        )
        return data;
    }

    async postGroupChat(formData) {
        // this.setAccessToken(accessToken, companyId);

        const data = await axios.post(
            Config.BACKEND_URL + `/api/group/message`,
            formData
            // this.config
        )
        return data;
    }


    async postClearChat(formData) {
        // this.setAccessToken(accessToken, companyId);

        const data = await axios.post(
            Config.BACKEND_URL + `/api/chat/clear`,
            formData
            // this.config
        )
        return data;
    }

    async postClearGroupChat(formData) {
        // this.setAccessToken(accessToken, companyId);

        const data = await axios.post(
            Config.BACKEND_URL + `/api/group/clear`,
            formData
            // this.config
        )
        return data;
    }

    async removeUnreadMessages(userDetailsId,groupchatid) {
        // this.setAccessToken(accessToken, companyId);

        const data = await axios.post(
            Config.BACKEND_URL + `/api/group/message/removeunread`,
            {
                userDetailsId:userDetailsId,
                groupchatid:groupchatid
            }
            // this.config
        )
        return data;
    }

    async removeUnreadMessagesDirect(senderId,receiverId,chatid) {
        // this.setAccessToken(accessToken, companyId);

        const data = await axios.post(
            Config.BACKEND_URL + `/api/chat/removeUnread`,
            {
                senderId:senderId,
                receiverId:receiverId,
                chatid:chatid
            }
            // this.config
        )
        return data;
    }


}

export default new ChatService();
